<template>
  <!--<nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav>-->
  <router-view />
</template>




<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600;700;800&family=Roboto&display=swap');

#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #000;
}

nav a.router-link-exact-active {
  color: #92C400;
}
</style>
<script>

export default {
  name: "App",
  data() {

  },
  created() {

  },
  watch: {
    $route(to) {
      document.title = to.meta.title || 'Sigma Farmers Market';
    },
  },
  methods: {

  }
};
</script>
